// @ts-nocheck
export default function multiply(num_str: any) {
  if (!num_str) return num_str
  num_str = num_str.toString()
  if (num_str.indexOf('+') != -1) {
    num_str = num_str.replace('+', '')
  }
  if (num_str.indexOf('E') != -1 || num_str.indexOf('e') != -1) {
    var resValue = '',
      power = '',
      result = null,
      sym = ''
    var numStr = num_str.toString()

    // 处理负号
    if (numStr[0] == '-') {
      numStr = numStr.substr(1)
      sym = '-'
    }

    if (numStr.indexOf('E') != -1 || numStr.indexOf('e') != -1) {
      var regExp = new RegExp('^(((\\d+.?\\d+)|(\\d+))[Ee]{1}((-(\\d+))|(\\d+)))$', 'ig')
      result = regExp.exec(numStr)
      if (result != null) {
        resValue = result[2]
        power = result[5]
        result = null
      }
      if (!resValue && !power) {
        return false
      }

      // 去掉小数点
      let numberStr = resValue.replace('.', '')
      power = Number(power)

      if (power >= 0) {
        // 处理正指数
        let zeros = '0'.repeat(power)
        resValue = numberStr + zeros
      } else {
        // 处理负指数
        let absExp = Math.abs(power)
        // 添加前导零
        resValue = '0.' + '0'.repeat(absExp - 1) + numberStr
      }

      // 移除末尾的小数点
      if (resValue.endsWith('.')) {
        resValue = resValue.slice(0, -1)
      }

      return sym + resValue
    }
    return sym + resValue
  } else {
    return num_str
  }
}
